import { render, staticRenderFns } from "./WebAppCreated.vue?vue&type=template&id=9c85641e"
import script from "./WebAppCreated.vue?vue&type=script&lang=js"
export * from "./WebAppCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports